<template lang="pug">
  div.btn-group.btn-group-toggle
    template(v-for="(option, index) in options")
      input(
        type="radio"
        :name="namespace"
        :value="option.value"
        :id="namespace + index"
        :checked="option.value == model"
        v-model="pick"
      )
      label.btn(
        role="button"
        :for="namespace + index"
      ) {{ option.label }}
</template>

<script>
export default {
  computed: {
    pick: {
      get() {
        return this.model;
      },
      // setter
      set(newValue) {
        this.$emit('select', newValue);
      }
    }
  },

  props: {
    options: {
      required: true,
      type: Array
    },
    model: {
      required: true
    },
    namespace: {
      required: true,
      type: String
    }
  }
};
</script>
